import { Grid } from "@mui/material";

function ContactUsPage() {
  
  return (
    // <div style={{ marginTop: "6pc", marginBottom: "2pc" }}>
    //   <Container>
    //     <h2>Contact Us</h2>
    //     <br></br>
    //     <p>For more information or to arrange a demo of the Care Passport portal, 
    //     email us at help@carepassport.ca</p>
    //     </Container>
    //     </div>
    <Grid container>
      <Grid xs={2} md={2}>
       </Grid>
      <Grid xs={8} md={8} style={{ minHeight:"25pc", justifyContent: "center", alignContent: "center", color: "#006699", fontFamily: "'Open Sans', sans-serif" }}>
        <h2 className="display-5">For more information or to arrange a demo of the Care Passport portal <br></br><br></br>Email us at - help@carepassport.ca</h2>
      </Grid>
      <Grid xs={2} md={2}>
      </Grid>
    </Grid>
  )
}

export default ContactUsPage;
